<!-- table列操作按钮 -->
<template>
    <div class="operate-content" @click="operateClick" :style="operateContentStyle"
        :class="isDisabled() ? 'operate-disabled' : 'operate'">
        <template v-if="!tooltipText">
            <i class="iconfont" :class="iconName" :style="iconStyle"></i>
            <slot v-if="!soltText">
                <span>{{ i18nConfig(text) }}</span>
            </slot>
            <template v-else>
                {{ i18nConfig(soltText) }}
            </template>
        </template>
        <template v-else>
            <el-tooltip>
                <template #title>{{ i18nConfig(tooltipText) }}</template>
                <i class="iconfont" :class="iconName" :style="iconStyle"></i>
                <slot>
                    <span>{{ i18nConfig(text) }}</span>
                </slot>
            </el-tooltip>
        </template>
    </div>
</template>
<script>
import { i18nConfig } from '@/utils/ruoyi'
import hasPermiJs from "@/directive/permission/hasPermi.js";
import { reactive, ref, toRefs, getCurrentInstance, onMounted } from 'vue';
export default {
    name: "table-column-operate",
    emits: ["click"],
    /**
     * <gljy-table-column-operate iconName="icon-xinzeng" text="操作"  tooltipText="我是提示文字" disabled
            @click="operateClick"></gljy-table-column-operate>
     */
    props: {
        /** 全局操作样式配置, 主要目的是配置文字显示颜色 */
        operateContentStyle: {
            type: String,
            default: ""
        },
        /** 图标名称 */
        iconName: {
            type: String
        },
        /** 图标样式 */
        iconStyle: {
            type: String
        },
        /** 显示文字 */
        text: {
            type: String
        },
        /** 悬浮提示文字 */
        tooltipText: {
            type: String
        },
        /** 判断是否有权限 */
        hasPermi: {
            type: [Array, String]
        },
        /** 是否禁用 */
        disabled: {
            type: Boolean
        }
    },
    setup(props, context) {
        const datas = reactive({
            soltText: undefined,
            i18nConfig
        })
        const { proxy } = getCurrentInstance();
        const methods = {
            /** 点击事件 */
            operateClick() {
                if (methods.isDisabled()) return;
                context.emit("click")
            },
            isDisabled() {
                if (typeof props.hasPermi == "string") {
                    if (!hasPermiJs.checkIsPermi([props.hasPermi])) return true;
                } else if (props?.hasPermi?.length > 0) {
                    if (!hasPermiJs.checkIsPermi(props.hasPermi)) return true;
                }

                if (props.disabled) return true;
            }
        }

        onMounted(() => {
            nextTick(() => {
                try {
                    const slotDefault = proxy.$slots?.default();
                    if (slotDefault.length == 1 && typeof slotDefault[0].type == "symbol") {
                        datas.soltText = slotDefault[0].children;
                    }
                } catch (e) {
                }
            })
        })

        return {
            ...methods,
            ...toRefs(datas)
        }
    }
}
</script>
  
<style lang="scss" scoped>
.operate-content {
    display: flex;
    display: inline-block;
    align-items: center;
}

.operate {
    cursor: pointer;
    color: #2E54EC
}

.operate-disabled {
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.5) !important;
}
</style>